import { createFileRoute } from "@tanstack/react-router"
import { Module } from "~/components/design-system/pages"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import Components from "~/pages/development/components"

export const Route = createFileRoute("/_auth/internal/development/components")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Module breadcrumb={<BreadcrumbWrapper />}>
      <Components />
    </Module>
  )
}
